export enum PinCodeMode {
  PIN_CODE_GENERATE = 'PIN_CODE_GENERATE',
  PIN_CODE_AUTH_SIGNAL = 'PIN_CODE_AUTH_SIGNAL',
}

export const pinCodeModeDefault = PinCodeMode.PIN_CODE_GENERATE;

export const pinCodeModes = [
  PinCodeMode.PIN_CODE_GENERATE,
  PinCodeMode.PIN_CODE_AUTH_SIGNAL,
];

export const authLoginSignal = 'Auth.login';
